export default __webpack_public_path__ + "static/verse2x-e89b2de142986a0e4380c920af417220.png";